import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import {
	AuthService,
	Container,
	i18n,
	ILearningExperience,
	LearningExperienceType,
	ProgressionStatus,
	EnrollmentStatus,
} from '../../../../symphony';

import { SlLEContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './CourseItemV2.scss';

interface ICourseItemV2Props {
	course: ILearningExperience;
	showStatuse?: boolean;
}

export function CourseItemV2({
	course,
	showStatuse = false,
}: ICourseItemV2Props): JSX.Element {
	useStyles(s);
	const {
		alias,
		name,
		uiConfigurations,
		typeId,
		progressionStatusId,
		enrollmentStatusId,
	} = course;

	const authService = Container.take('global', AuthService);

	const isLoggedIn = authService?.isLoggedIn();

	const isLearningPath = typeId === LearningExperienceType.LearningPath;

	const handleCourseItemClick = (): void => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: isLearningPath
				? ActionType.OnLearningPathClick
				: ActionType.OnCourseClick,
			requestType: RequestType.Parallel,
			data: {
				alias,
			},
		});
	};

	const getLinkToCourse = (): string => `/learn/${isLearningPath ? 'learning-paths' : 'courses'
	}/${alias}`;

	return (
		<LocalizedLink
			onClick={handleCourseItemClick}
			to={getLinkToCourse()}
			className={`le-course-item-v2${isLoggedIn ? '' : ' non-logged'}`}
			sl-test-data={`cmpCourseItemV2${alias}`}
		>
			<div className="le-course-item-v2__icon">
				<img src={uiConfigurations.iconUrl} alt={alias} />
			</div>
			<div className="le-course-item-v2__info">
				<p
					className={`le-course-item-v2__title${isLoggedIn ? '' : ' non-logged'
					}`}
				>
					{name}
				</p>
				{showStatuse
					&& enrollmentStatusId === EnrollmentStatus.Enrolled
					&& (progressionStatusId === ProgressionStatus.Completed ? (
						<p className="le-course-item-v2__description le-course-item-v2__description--complete">
							{i18n.t('web-le.course-catalog-complete-status')}
						</p>
					) : (
						<p className="le-course-item-v2__description le-course-item-v2__description--in-progress">
							{i18n.t('web-le.course-catalog-in-progress-status')}
						</p>
					))}
			</div>
		</LocalizedLink>
	);
}
